module.exports = __webpack_public_path__ + "static/media/portfolio9.0bbfad48.jpg";